export default class DomEventHelper {
  static createEvent(name, detail) {
    let event;

    if((window).CustomEvent) {
      event = new CustomEvent(name, {
        bubbles: true,
        detail,
      });
    } else {
      event = document.createEvent(`CustomEvent`);
      event.initCustomEvent(name, true, true, {
        detail,
      });
    }
    return event;
  }

  /**
   * @param {{ name: string, [detail]:  any } | FireEventOptions} options
   */
  static fireEvent(options) {
    const event = DomEventHelper.createEvent(options.name, options.detail);
    document.dispatchEvent(event);
  }
}
